exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".maxCharCount{display:inline;font-weight:400;font-size:11px;color:#888}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/newsletter-distributions/send-again-dialog/send-again-dialog.component.css
 ** module id = 47
 ** module chunks = 0 1
 **/